module.exports = __webpack_public_path__ + "static/body-background-fddeb375163d9787bc2709d74d0bd33f.png";